export const GET_DOMAINS = 'dns/GET_DOMAINS';
export const GET_DOMAINS_SUCCESS = 'dns/GET_DOMAINS_SUCCESS';
export const GET_DOMAINS_FAIL = 'dns/GET_DOMAINS_FAIL';

export const GET_DOMAIN_RECORDS = 'dns/GET_DOMAIN_RECORDS';
export const GET_DOMAIN_RECORDS_SUCCESS = 'dns/GET_DOMAIN_RECORDS_SUCCESS';
export const GET_DOMAIN_RECORDS_FAIL = 'dns/GET_DOMAIN_RECORDS_FAIL';

export const EDIT_RECORD = 'dns/EDIT_RECORD';
export const EDIT_RECORD_SUCCESS = 'dns/EDIT_RECORD_SUCCESS';
export const EDIT_RECORD_FAIL = 'dns/EDIT_RECORD_FAIL';

export const ADD_RECORD = 'dns/ADD_RECORD';
export const ADD_RECORD_SUCCESS = 'dns/ADD_RECORD_SUCCESS';
export const ADD_RECORD_FAIL = 'dns/ADD_RECORD_FAIL';


export const DNS_RECORDS_SEARCH = 'dns/DNS_RECORDS_SEARCH';



// WEBPACK FOOTER //
// ./src/redux/constants/dns.js